import { apiPost } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

export async function updateFrguSync(): Promise<void> {
  return apiPost<void>({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/frgu-sync` });
}
